import  request  from '../../Interceptor/request.js'

//后付费电表获取内容
export function postpaid(params) {
    return request({
        url: '/eleBill/list',
        method: 'get',
        params:params
    })
}

//期数具体数据
export function periods(data){
    return request({
        url:'/eleBill/list',
        method: 'get',
        params:data
    })
}

//查询账单
export function billList(data){
    return request({
        url:'/order',
        method: 'post',
        data:data
    })
}

//请求账单号
export function billData(){
    return request({
        url:'/pay/wxPay/mp-pay',
        method:'get'
    })
}

//查询返回
export function endList(){
    return request({
        url:'/order/list',
        method:'get'
    })
}